import type { SxProps, Theme } from "@mui/material";
import { Box } from "@mui/material";

interface PevLogoProps {
  size?: number;
  sx?: SxProps<Theme>;
}

/**
 * Inline SVG logo extracted from pev-logo.svg favicon.
 * Renders the gradient envelope + checkmark badge + validation dots
 * without the dark background tile (suitable for in-app use).
 */
export function PevLogo({ size = 28, sx }: PevLogoProps) {
  return (
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="8 10 48 40"
      sx={{ width: size, height: size, display: "block", ...sx }}
    >
      <defs>
        <linearGradient
          id="pev-g"
          x1="8"
          y1="6"
          x2="56"
          y2="58"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#22c55e" />
          <stop offset="0.55" stopColor="#14b8a6" />
          <stop offset="1" stopColor="#2563eb" />
        </linearGradient>
        <filter id="pev-s" x="-30%" y="-30%" width="160%" height="160%">
          <feDropShadow
            dx="0"
            dy="1"
            stdDeviation="1"
            floodColor="#000"
            floodOpacity="0.25"
          />
        </filter>
      </defs>
      <g filter="url(#pev-s)">
        {/* Envelope base */}
        <path
          fill="none"
          stroke="url(#pev-g)"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M16 22.5h32a4 4 0 0 1 4 4V42a4 4 0 0 1-4 4H16a4 4 0 0 1-4-4V26.5a4 4 0 0 1 4-4z"
        />
        {/* Envelope flap */}
        <path
          fill="none"
          stroke="url(#pev-g)"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M14 27l18 12 18-12"
        />
        {/* Checkmark badge */}
        <circle
          cx="47.5"
          cy="20.5"
          r="8.5"
          fill="white"
          stroke="url(#pev-g)"
          strokeWidth="3"
        />
        <path
          fill="none"
          stroke="url(#pev-g)"
          strokeWidth="3.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M43.2 20.4l3 3.2 5.8-6.4"
        />
        {/* Validation dots */}
        <circle cx="18" cy="18" r="1.6" fill="#22c55e" opacity="0.9" />
        <circle cx="23" cy="16" r="1.3" fill="#14b8a6" opacity="0.85" />
        <circle cx="28" cy="14.5" r="1.1" fill="#2563eb" opacity="0.8" />
      </g>
    </Box>
  );
}
